export default __webpack_public_path__ + "static/media/mpcg_tigers_grap_chart.cdcdd930.jpg";